export default new Audio();